export async function trackEvent(userId, action) {
    console.log("flevent", userId, action)
    const data = {
        "who": userId,
        "action": action
    }

    await fetch('https://t.feedletter.co/api/collections/flevents/records', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
    })
}